import { render, staticRenderFns } from "./mineCollection.vue?vue&type=template&id=689341c4&scoped=true&"
import script from "./mineCollection.vue?vue&type=script&lang=js&"
export * from "./mineCollection.vue?vue&type=script&lang=js&"
import style0 from "./mineCollection.vue?vue&type=style&index=0&id=689341c4&prod&scoped=true&lang=css&"
import style1 from "./mineCollection.vue?vue&type=style&index=1&id=689341c4&prod&scoped=true&lang=scss&"
import style2 from "./mineCollection.vue?vue&type=style&index=2&id=689341c4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "689341c4",
  null
  
)

export default component.exports